import React, { useEffect, useState } from 'react';

import * as libCon from '../community-hats-js-library/Constants';
import * as locCon from '../LocalConstants';
import { RefATOField, setStoredValue, StateStoredBooleanValue } from '../hooks/StoreHooks';

import { showErrorDialogByCode } from '../utils/dialogFunctions';
import { testFitbitApiForEmail } from '../community-hats-js-library/back-end/router';
import CustomText from '../elements/CustomText';
import CustomSpin from '../elements/CustomSpin';
import { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { RefContextLanguage } from '../providers/LanguageProvider';

// Verifies that this account's Fitbit credentials can actually read data.
//
// This used to test three values the manager had pasted in and then write them
// onto the email object so the next sync would push them to Airtable. It does
// neither now: the OAuth callback on the server is the only thing that ever
// holds a Fitbit token, and this only asks whether the grant works. A pass
// records nothing but that.
export function TestFitibitApiButton({ checkboxId = null }) {
  const i18n = RefContextLanguage();

  const email = RefATOField(locCon.AT_OBJECT_EMAIL_ACCOUNT, libCon.ATF_EMAIL);

  const [apiOk, setApiOk] = StateStoredBooleanValue(locCon.FITBIT_API_OK);

  const [testing, setTesting] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [warningText, setWarningText] = useState(() => null);

  useEffect(() => {
    if (isNullOrUndefined(email)) {
      setDisabled(true);
      setWarningText(libCon.ATF_EMAIL);
      setApiOk(false);
    } else setDisabled(false);
  }, [email, setApiOk]);

  const testApi = async () => {
    setTesting(true);

    const code = await testFitbitApiForEmail(email);

    if (code === libCon.OK) {
      setApiOk(true);
      setStoredValue(checkboxId, true);
    } else {
      showErrorDialogByCode(code);
      setStoredValue(checkboxId, false);
    }

    setTesting(false);
  };

  return (
    <div className="verticalSection">
      {apiOk === true ? (
        <CustomText type={locCon.ELEMENT_TEXT}>{i18n.t('successFitbitAPI')}</CustomText>
      ) : testing === true ? (
        <CustomSpin type={locCon.BUTTON_SPINNER} />
      ) : (
        <CustomPrimaryButtonWithDisability
          isDisabled={disabled}
          title={i18n.t('missingValues')}
          description={warningText}
          onClick={() => testApi()}
        >
          {i18n.t('testApi')}
        </CustomPrimaryButtonWithDisability>
      )}
    </div>
  );
}

export default TestFitibitApiButton;
